<template>
    <div class="your-dates__date">
        <label>
            <div class="form__checkbox">
                <input v-model="selected_date" class="input--checkbox" type="checkbox"
                       name="checkbox_example">
                <span class="checkbox-text"></span>
            </div>
            <div class="your-dates__date-title">
                {{day.date|moment('dddd')}}
                <strong>{{day.date|moment('D. MMM YYYY')}}</strong>
            </div>
            <div v-if="!multiple" class="your-dates__category">
                <span class="main-category-icon" :class="'icon-'+day.icon"
                      :title="'Category: '+day.category_name"></span>
                {{day.name}}
            </div>
            <template v-if="multiple">
            <div v-for="supported in day.supported" class="your-dates__category" :key="supported.name+supported.category_name">
                <span class="main-category-icon" :class="'icon-'+supported.icon"
                      :title="'Category: '+supported.category_name"></span>
                {{supported.name}}
            </div>
            </template>

            <div class="your-dates__date-strength">
                <translate>Strength of your day</translate>:&nbsp;<day-strength :strength="day.strength"></day-strength>
            </div>
            <!--
            <div class="your-dates__planned-activity-details">
                Already planned activites on this day
                <div class="your-dates__planned-activity-categories">
                                            <span class="main-category-icon icon-real-estate objective-color__background-color--12"
                                                  title="Category: Real Estate | Subcategory: XYZ"></span>
                    <span class="main-category-icon icon-business objective-color__background-color--17"
                          title="Category: Business | Subcategory: XYZ"></span>
                </div>
            </div>
            -->
        </label>
    </div>
</template>
<script>
    import DayStrength from "../../components/calendar/DayStrength";

    export default {
        name: 'energy-supported-date',
        components: {DayStrength},
        props: {
            day: {},
            multiple: {type:Boolean, default:false},
            value: {},
            activity: {}
        },
        computed: {
            selected_date: {
                get: function () {
                    return this.value == this.day.date
                },

                set: function (newValue) {
                    if (newValue) {
                        this.$emit('input', this.day.date)
                        this.$set(this.activity, 'strength', this.day.strength)
                    } else {
                        this.$emit('input', null)
                        this.$set(this.activity, 'strength', null)
                    }

                }
            }
        }
    }
</script>